import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { ReactNode } from "react";

function StyledModalFooter({ children }: { children: ReactNode }) {
  return (
    <FixaModalFooter renderBorder stacked>
      {children}
    </FixaModalFooter>
  );
}

export default StyledModalFooter;
